module.exports = __webpack_public_path__ + "035ed7c66550e58c66a5007a1b76e45f.png";